import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import uniLogo from './../../images/uniempleo-logo-nuevo.png';
import bnr from '../../images/portada-uniempleo.png';

export function RegisterOnboarding() {
    const history = useHistory();

    // Verificar si el registro de usuarios está habilitado desde variable de entorno
    const ENABLE_USER_REGISTRATION = process.env.REACT_APP_ENABLE_USER_REGISTRATION === 'true';

    // Si el registro de usuarios está deshabilitado, redirigir directamente a registro de empresa
    useEffect(() => {
        if (!ENABLE_USER_REGISTRATION) {
            localStorage.setItem('registerUserType', 'employer');
            history.push('/register-2?type=employer');
        }
    }, []);

    const handleSelectType = (userType) => {
        // Guardar el tipo en localStorage para persistencia
        localStorage.setItem('registerUserType', userType);
        // Redirigir a la página de registro con el tipo como query param
        history.push(`/register-2?type=${userType}`);
    };

    return (
        <div className="page-wraper">
            <div className="browse-job login-style3">
                <div className="dez-bnr-inr dez-bnr-inr-md overlay-black-middle" style={{ backgroundImage: `url(${bnr})`, height: "100vh" }}>
                    <div className="row" style={{ height: "100vh", overflow: "hidden" }}>
                        <div className="col-xl-6 col-lg-7 col-md-8 col-sm-12 bg-white z-index2 relative p-a0 content-scroll skew-section left-bottom m-auto" style={{ maxHeight: "100vh", overflowY: "auto" }}>
                            <div className="login-form style-2" style={{ paddingTop: "20px" }}>
                                <div className="logo-header text-center p-tb30 " >
                                    <Link to={"./"}><img src={uniLogo} alt="UNIEMPLEO" className='' /></Link>
                                </div>
                                <div className="clearfix"></div>
                                <div className="tab-content nav p-b30 tab">
                                    <div id="onboarding" className="tab-pane active">
                                        <div className="dez-form p-b30">
                                            <h3 className="form-title m-t0 text-center">Únete a UNIEMPLEO</h3>

                                            <p className="text-center m-b20" style={{ fontSize: '1rem', color: '#666', lineHeight: '1.6' }}>
                                                <strong>UNIEMPLEO</strong> es el vínculo entre <strong>PROFESIONAL/ESTUDIANTE – EMPRESA</strong>.
                                                {ENABLE_USER_REGISTRATION 
                                                    ? 'Conecta tu talento con las mejores oportunidades laborales del ecosistema universitario y empresarial.'
                                                    : 'Registra tu empresa y publica ofertas de trabajo para conectar con el mejor talento.'}
                                            </p>

                                            <div className="row">
                                                {/* Opción de usuario/aplicante - Solo si está habilitado */}
                                                {ENABLE_USER_REGISTRATION && (
                                                    <div className="col-lg-6 col-md-6 col-sm-12 m-b20">
                                                        <button
                                                            type="button"
                                                            className="job-bx bg-white p-a30 text-center w-100"
                                                            onClick={() => handleSelectType('applicant')}
                                                            style={{
                                                                cursor: 'pointer',
                                                                border: '3px solid #dee2e6',
                                                                borderRadius: '12px',
                                                                transition: 'all 0.3s ease',
                                                                backgroundColor: '#fff',
                                                                boxShadow: '0 4px 15px rgba(222, 226, 230, 0.1)',
                                                                padding: '40px 30px',
                                                                outline: 'none'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.borderColor = '#adb5bd';
                                                                e.currentTarget.style.transform = 'translateY(-8px)';
                                                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(222, 226, 230, 0.25)';
                                                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.borderColor = '#dee2e6';
                                                                e.currentTarget.style.transform = 'translateY(0)';
                                                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(222, 226, 230, 0.1)';
                                                                e.currentTarget.style.backgroundColor = '#fff';
                                                            }}
                                                        >
                                                            <div className="m-b20">
                                                                <i className="fa fa-user" style={{ fontSize: '64px', color: '#adb5bd' }}></i>
                                                            </div>
                                                            <h4 className="m-b15" style={{ fontSize: '1.5rem', fontWeight: 700, color: '#333' }}>Busco Trabajo</h4>
                                                            <p className="m-b0" style={{ fontSize: '1rem', color: '#666', lineHeight: '1.6' }}>Busco empleo como estudiante, egresado o profesional externo a la universidad</p>
                                                        </button>
                                                    </div>
                                                )}
                                                
                                                {/* Opción de empresa - Siempre disponible */}
                                                <div className={ENABLE_USER_REGISTRATION ? "col-lg-6 col-md-6 col-sm-12 m-b20" : "col-lg-8 col-md-10 col-sm-12 m-b20 mx-auto"}>
                                                    <button
                                                        type="button"
                                                        className="job-bx bg-white p-a30 text-center w-100"
                                                        onClick={() => handleSelectType('employer')}
                                                        style={{
                                                            cursor: 'pointer',
                                                            border: '3px solid #dee2e6',
                                                            borderRadius: '12px',
                                                            transition: 'all 0.3s ease',
                                                            backgroundColor: '#fff',
                                                            boxShadow: '0 4px 15px rgba(222, 226, 230, 0.1)',
                                                            padding: '40px 30px',
                                                            outline: 'none'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.borderColor = '#adb5bd';
                                                            e.currentTarget.style.transform = 'translateY(-8px)';
                                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(222, 226, 230, 0.25)';
                                                            e.currentTarget.style.backgroundColor = '#f8f9fa';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.borderColor = '#dee2e6';
                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(222, 226, 230, 0.1)';
                                                            e.currentTarget.style.backgroundColor = '#fff';
                                                        }}
                                                    >
                                                        <div className="m-b20">
                                                            <i className="fa fa-building" style={{ fontSize: '64px', color: '#adb5bd' }}></i>
                                                        </div>
                                                        <h4 className="m-b15" style={{ fontSize: '1.5rem', fontWeight: 700, color: '#333' }}>Busco Contratar</h4>
                                                        <p className="m-b0" style={{ fontSize: '1rem', color: '#666', lineHeight: '1.6' }}>Tengo una empresa y quiero publicar ofertas de trabajo</p>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-center bottom">
                                            <Link to="/login" className="site-button button-md btn-block text-white " style={{ backgroundColor: '#009247' }}>¿Ya tienes una cuenta? Inicia sesión aquí</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="bottom-footer clearfix m-t10 m-b20 row text-center">
                                    <div className="col-lg-12 text-center">
                                        <span> © {new Date().getFullYear()} UNIEMPLEO - Universidad del Caribe. Todos los derechos reservados.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}